export const atLeastThreeLowerCaseCharacters = /^(.*?[a-z]){3,}.*$/;
